import ns from '../../utilities/namespace.js';

export const RootEmission = {
  CLICK: ns.emission('root', 'click'),
  INTERACTION: ns.emission('root', 'interaction'),
  KEYDOWN: ns.emission('root', 'keydown'),
  KEYUP: ns.emission('root', 'keyup')
};
